import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SidePane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Pisco from "pisco-ui";
import "pisco-ui/lib/styles.css";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import "../../../styles/pisco-pane.scss";
import ArticlePreview from "../../article/view/article-preview.jsx";
import UnifiedImagePicker from "../../media-picker/unified-image-picker.jsx";
import { logArticleImageSource } from "../../media-picker/image-source-log.js";


import ArticleDetailsContainer from "./article-details-container.jsx";
import { getArticleDetailsFromArticleId } from "app-selector.js";
import {
  setArticleVideoHeader,
  deleteArticleVideoheader,
  hidePiscoModal,
  setPiscoContent,
  showPiscoModal as showPiscoModalAction,
  setCoverPictureUrl,
  setArticleCoverCaption,
  clearArticleCoverCaption,
} from "../new-story-actions.js";
import { PiscoContentTypes, ArticleTypes } from "app-constants";
import AppLoader from "app-components/app-loader.jsx";

import CoverPicture from "./cover-picture.jsx";
import GalleryContents from "./gallery-content.jsx";
import StoryContents from "./story-content.jsx";
import ApprovalSubmit from "./approval-submit.jsx";

import { setArticleIdForPreviewArticle, setLastLocation } from "../../article/article-action.js";

// Carry the asset's credit/photographer into the cover caption (plain text,
// idempotent) so attribution entered in the Pisco Credit/Photographer field is
// not dropped. Convention: "caption — Credit". Stored as cover_caption.
function composeCoverCaption(content) {
  if (!content) return "";
  var credit = ((content.credit || content.photographer) || "").toString().trim();
  if (!credit) return content.caption; // unchanged behaviour when there's no credit
  var caption = (content.caption || "").trim();
  if (caption && caption.indexOf(credit) !== -1) return content.caption; // already carries credit
  return caption ? (caption + " — " + credit) : credit;
}

// Swap the legacy embedded <Pisco> for the unified Media Library + Pisco picker
// in the article editor. Off by default; flip REACT_APP_UNIFIED_PICKER=true.
const UNIFIED_PICKER = process.env.REACT_APP_UNIFIED_PICKER === "true";

class StoryPageContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isPaneOpen: false,
      isPaneOpenLeft: false
    };
    this.tinyMCEEditor = React.createRef();
  }
  _hidePiscoModal() {
    this.setState({
      activePiscoContent: undefined
    });
    this.props.hidePiscoModal();
  }

  goToArticles = () => {
    //this.props.clearArticleCoverCaption();
    this.props.setLastLocation('edit-page');
    this.props.history.push("/cms/articles");
  }
  componentWillUnmount() {
    this.props.clearArticleCoverCaption();
  }
  render() {
    const {
      setArticleIdForPreviewArticle,
      deleteArticleVideoheader,
      contentType,
      activePiscoContentType,
      showPiscoModalAction,
      setArticleVideoHeader,
      shareType,
      isCreatingNewArticle,
      activeDomain,
      setLastLocation
    } = this.props;
    if (isCreatingNewArticle) {
      return <AppLoader />
    }
    let piscoType = "Both";
    if (activePiscoContentType === PiscoContentTypes.COVER_IMAGE) {
      piscoType = "Image"
    }
    if (activeDomain != 15 && activeDomain != 107) {
      piscoType = "Image"
    }

    const isCover = activePiscoContentType === PiscoContentTypes.COVER_IMAGE;
    // The unified image picker (Media Library + Pisco + article-local Upload) is
    // used for ALL image picks — covers AND body, on every domain. Previously the
    // body on video-enabled domains 15/107 fell back to legacy <Pisco> so editors
    // could embed pisco-uploaded videos; that exception is retired — the
    // images-only unified picker is used there too, and URL/iframe videos go
    // through the "Embed" toolbar button.
    const useUnified = UNIFIED_PICKER;

    // Shared embed handler — identical to the legacy inline closure, plus a
    // non-blocking provenance log. Used by BOTH the unified picker and <Pisco>.
    const handleEmbed = (content) => {
      if (content.cdn) content.cdn = content.cdn.replace('small_200_', '');
      if (content.s3Url) content.s3Url = content.s3Url.replace('small_200_', '');
      if (isCover) {
        this.props.setCoverPictureUrl(content.cdn);
        this.props.setArticleCoverCaption(composeCoverCaption(content));
      } else {
        this.props.setPiscoContent(content);
      }
      logArticleImageSource({
        articleId: this.props.articleId,
        domainId: activeDomain,
        placement: isCover ? 'cover' : 'body',
        source: content.__source || 'library_pisco',
        assetUrl: content.cdn,
        publicId: content.publicId || content.id || null
      });
      this.props.hidePiscoModal();
    };

    return (
      <Fragment>
        <GridContainer>
          <GridItem xs={false} md={2}></GridItem>
          <GridItem xs={12} md={8} style={{ border: '1px solid #ced3dc', borderRadius: '2px' }}>
            <div style={{padding:'30px 20px'}}>
            <CoverPicture activePiscoContentType={activePiscoContentType} onPiscoOpen={showPiscoModalAction} setPictureUrl={this.props.setCoverPictureUrl} />
            <ArticleDetailsContainer setArticleIdForPreviewArticle={setArticleIdForPreviewArticle} tinyMCEEditor={this.tinyMCEEditor}/>
            {
              <StoryContents activePiscoContentType={activePiscoContentType} tinyMCEEditor={this.tinyMCEEditor}/>
              // contentType == ArticleTypes.ARTICLE &&
              // <StoryContents activePiscoContentType={activePiscoContentType} /> ||
              // <GalleryContents activePiscoContentType={activePiscoContentType} />
            }
            <ApprovalSubmit goToArticles={this.goToArticles} />
            <ArticlePreview />
            </div>
          </GridItem>
        </GridContainer>
        <SidePane
            overlayClassName='pisco-pane'
            isOpen={this.props.showPiscoModal}
            title={useUnified ? 'MEDIA' : 'PISCO'}
            subtitle='Media Search'
            from='right'
            width='80%'
            onRequestClose={this.props.hidePiscoModal}
          >
            {useUnified ? (
              <UnifiedImagePicker
                endpoint={process.env.REACT_APP_API_SERVER}
                headers={{ authorization: localStorage.getItem('accessToken') }}
                injectQuery={{ domainId: activeDomain, cover_img: isCover ? 1 : 0 }}
                isCover={isCover}
                allowQuickAdd={!isCover}
                type="Image"
                disableGetty={this.props.domain !== 'meaww'}
                articleId={this.props.articleId}
                activeDomain={activeDomain}
                onEmbed={handleEmbed}
                onClose={this.props.hidePiscoModal}
              />
            ) : (
              <Pisco
                endpoint={process.env.REACT_APP_API_SERVER}
                headers={{ authorization: localStorage.getItem('accessToken') }}
                injectQuery={{ domainId: activeDomain, cover_img: isCover ? 1 : 0 }}
                disableGetty={this.props.domain !== 'meaww'}
                type={piscoType}
                mode="embed"
                onEmbed={handleEmbed}
              />
            )}
          </SidePane>
      </Fragment>

    );
  }
}
const mapStateToProps = (state) => {
  const {
    cms: {
      articleSettings: {
        articleId
      },
      newStory: {
        showPiscoModal,
        activePiscoContentType
      }
    },
    login: { user }
  } = state;
  const articleDetails = getArticleDetailsFromArticleId(state.cms, articleId);
  //remvoe default value
  const { contentType, domain = "meaww", shareType = "meaww" } = articleDetails;
  return {
    articleId,
    showPiscoModal,
    activePiscoContentType,
    shareType: shareType,
    domain: domain,
    contentType: contentType,
    activeDomain: user.activeDomain
  }
}

const mapDispatchToProps = dispatch => ({
  hidePiscoModal: () => dispatch(hidePiscoModal()),
  showPiscoModalAction: (piscoContentType) => dispatch(showPiscoModalAction(piscoContentType)),
  setPiscoContent: (content) => dispatch(setPiscoContent(content)),
  setCoverPictureUrl: url => dispatch(setCoverPictureUrl(url)),
  clearArticleCoverCaption: () => dispatch(clearArticleCoverCaption()),
  setArticleCoverCaption: url => dispatch(setArticleCoverCaption(url, null)),
  setArticleVideoHeader: (url) => dispatch(setArticleVideoHeader(url)),
  deleteArticleVideoheader: () => dispatch(deleteArticleVideoheader()),
  setLastLocation: (location) =>  dispatch(setLastLocation(location)),

  //preview
  setArticleIdForPreviewArticle: (articleId, states) => dispatch(setArticleIdForPreviewArticle(articleId, states))

})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StoryPageContent));
